"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.screenTemplate = void 0;
var tslib_1 = require("tslib");
var screen_dot_1 = (0, tslib_1.__importDefault)(require("./screen.dot"));
var screenTemplate = screen_dot_1.default.default ? screen_dot_1.default.default : screen_dot_1.default;
exports.screenTemplate = screenTemplate;
//# sourceMappingURL=index.js.map